import { FilterMatchMode } from '@primevue/core/api'
import type { DataTableFilterMetaData } from 'primevue/datatable'
import type { IFilterOptions } from './IFilterOptions'

export interface CustomDataTableFilterMeta {
  [key: string]: CustomDataTableOperatorFilterMetaData | DataTableFilterMetaData
}

export interface CustomDataTableFilterMetaData extends DataTableFilterMetaData {
  filterOptions: IFilterOptions
}

export interface CustomDataTableOperatorFilterMetaData {
  operator: string
  constraints: CustomDataTableFilterMetaData[]
}

type FilterMatchModeKey = keyof typeof FilterMatchMode
type FilterMatchModeValue = (typeof FilterMatchMode)[FilterMatchModeKey]

export type AnyMatchMode = FilterMatchModeKey | FilterMatchModeValue | string | undefined
export function normalizeMatchMode(mm: AnyMatchMode): FilterMatchModeValue {
  if (!mm) return FilterMatchMode.CONTAINS
  if (mm in FilterMatchMode) {
    return FilterMatchMode[mm as FilterMatchModeKey]
  }
  return mm as FilterMatchModeValue
}

export function isDateLike(v: unknown): boolean {
  if (v instanceof Date) {
    return !isNaN(v.getTime())
  }

  if (typeof v !== 'string') {
    return false
  }

  const s = v.trim()
  if (s.length < 6) {
    return false
  }

  const d = new Date(s)

  if (isNaN(d.getTime())) {
    return false
  }

  if (/^\d+$/.test(s)) {
    return false
  }

  const year = d.getFullYear()
  if (year < 1900 || year > 2100) {
    return false
  }

  return true
}

export function isNumberLike(v: unknown): boolean {
  return typeof v === 'number'
}

export function isBooleanLike(v: unknown): boolean {
  return typeof v === 'boolean'
}

export function isStringLike(v: unknown): boolean {
  return typeof v === 'string'
}
